import React from "react";
import { MAC_ST } from "@/components/erp/prod/MachineBoard";

const TONE = { AVAILABLE: "border-emerald-300 bg-emerald-50", RUNNING: "border-sky-400 bg-sky-50", MAINTENANCE: "border-amber-400 bg-amber-50", BREAKDOWN: "border-rose-400 bg-rose-50 ring-2 ring-rose-200", OFFLINE: "border-slate-300 bg-slate-100" };

const Tile = ({ m, onHealth }) => {
  const c = MAC_ST.find(([k]) => k === m.st) || MAC_ST[4];
  return (
    <button type="button" data-testid={`rack-tile-${m.code || m.id}`} onClick={() => onHealth(m)} className={`w-full text-left rounded-lg border-2 p-2 hover:-translate-y-0.5 transition-transform ${TONE[m.st] || TONE.OFFLINE}`}>
      <div className="flex items-center gap-1"><b className="text-sm truncate">{m.name}</b><span className={`ml-auto text-[10px] px-1.5 py-0.5 rounded-full ${c[2]}`}>{c[1]}</span></div>
      <div className="text-[10px] font-mono text-slate-500">{m.code} · {(m.type || "FDM").toUpperCase()}</div>
      {m.run && <div className="text-[11px] text-sky-800 truncate mt-0.5">{m.run.wo_code} · {m.run.file_name}</div>}
      {!m.run && m.status_note && <div className="text-[11px] text-slate-600 truncate mt-0.5">{m.status_note}</div>}
      {m.spools?.length > 0 && <div className="text-[10px] text-slate-500 truncate">{m.spools.map((s) => `${s.material} ${s.color || ""}`).join(", ")}</div>}
    </button>
  );
};

// Peta rak: mesin dikelompokkan per rak, warna sesuai status
export const RackMap = ({ machines, racks, onHealth }) => {
  const cols = [...racks].sort((a, b) => a.name.localeCompare(b.name, "id", { numeric: true })).map((r) => ({ ...r, ms: machines.filter((m) => m.rack_id === r.id) }));
  const none = machines.filter((m) => !racks.some((r) => r.id === m.rack_id));
  if (none.length) cols.push({ id: "none", name: "Belum di rak", ms: none });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3" data-testid="rack-map">
      {cols.map((r) => {
        const bad = r.ms.filter((m) => ["BREAKDOWN", "MAINTENANCE"].includes(m.st)).length; const run = r.ms.filter((m) => m.st === "RUNNING").length;
        return (
          <div key={r.id} className={`rounded-xl border p-2 ${r.id === "none" ? "border-dashed border-slate-300" : "border-slate-200 bg-slate-50/60"}`} data-testid={`rack-col-${r.id}`}>
            <div className="flex items-center text-xs font-semibold mb-2 px-1"><span>{r.name}</span><span className="ml-auto font-normal text-slate-500">{r.ms.length} mesin{run ? ` · ${run} jalan` : ""}{bad ? <b className="text-rose-600"> · {bad} rusak/servis</b> : ""}</span></div>
            <div className="space-y-2">{r.ms.map((m) => <Tile key={m.id} m={m} onHealth={onHealth} />)}{!r.ms.length && <p className="text-[11px] text-slate-400 px-1">Kosong</p>}</div>
          </div>
        );
      })}
    </div>
  );
};
